<template>
  <PForm
    v-model="validado"
    @cancel="cancel"
    @accept="action"
    :action="actionName"
    :textAction="$t('action.aceptar')"
    :textCancel="$t('label.cancelar')"
  >
    <template>
      <div style="min-height: 300px">
        <PRow>
          <PCol col="6">
            <PDataLine
              :value="{
                codUsuario: valueLocal.codUsuario,
                codEmail: valueLocal.codEmail,
                desNombre: valueLocal.desNombre,
                desApellidos: valueLocal.desApellidos,
                telefono: valueLocal.celular || '',
              }"
              :fields="{
                codUsuario: { title: $t('label.idUsuario'), width: '50%' },
                codEmail: { title: $t('label.email'), width: '50%' },
                desNombre: { title: $t('label.nombre'), width: '50%' },
                desApellidos: { title: $t('label.apellidos'), width: '50%' },
                telefono: { title: $t('label.telefono'), width: '50%' },
              }"
              :showBorder="true"
            />
          </PCol>
          <PCol col="6">
            <PDataLine
              :value="{
                roles: dameRoles,
              }"
              :fields="{
                roles: { title: $t('label.roles'), width: '100%', list: true },
              }"
              justifyContent="flex-start"
              :showBorder="true"
            >
              <template #roles>
                <span class="datalineList-item" v-for="rol in dameRoles" :key="rol">{{ rol }}</span>
              </template>
            </PDataLine>
          </PCol>
        </PRow>
        <PRow>
          <PCol col="6">
            <PDataLine
              v-if="valueLocal.configurado"
              :value="{
                codNivel: nivelUsuario,
              }"
              :fields="{
                codNivel: { title: $t('label.nivel'), width: '50%' },
              }"
              :showBorder="true"
            />
            <PFormSelect
              v-else
              v-model="valueLocal.nivel"
              :options="optionsNivel"
              optionValue="id"
              optionText="descNivel"
              :label="$t('label.nivel')"
              :placeholder="$t('option.select')"
              @change="selectNivel"
            />
          </PCol>
        </PRow>
        <PRow>
          <PCol md="12" v-if="valueLocal.nivel === rolePais">
            <PFormSelectTranslateItems
              v-model="valueLocal.paises"
              :options="optionsPaises"
              optionValue="id"
              optionText="descripcion"
              rules="required"
              :titleLeft="$t('label.pais')"
              :titleRight="$t('label.seleccionados')"
            />
          </PCol>
          <PCol
            col="6"
            v-else-if="valueLocal.nivel === roleCliente || valueLocal.nivel === roleDelegacion"
          >
            <PFormSelectMulti
              v-model="valueLocal.paises"
              :options="optionsPaises"
              optionValue="id"
              optionText="descripcion"
              :label="$t('label.pais')"
              :placeholder="$t('option.select')"
              @change="selectPaisMulti"
            />
          </PCol>
          <PCol col="6" v-else-if="valueLocal.nivel === rolePS">
            <PFormSelect
              v-model="valueLocal.paises"
              :options="optionsPaises"
              optionValue="id"
              optionText="descripcion"
              :label="$t('label.pais')"
              :placeholder="$t('option.select')"
              @change="selectPais"
              :valueAsArray="true"
            />
          </PCol>
          <PCol md="12" v-if="valueLocal.nivel === roleCliente && valueLocal.paises?.length">
            <PFormSelectTranslateItems
              v-model="valueLocal.clientes"
              :options="optionsClientesGroup"
              :sortLeft="false"
              :titleLeft="$t('label.cliente')"
              :titleRight="$t('label.seleccionados')"
              :group="true"
            />
          </PCol>
          <PCol
            col="6"
            v-else-if="valueLocal.nivel === roleDelegacion && valueLocal.paises?.length"
          >
            <PFormSelectMulti
              v-model="valueLocal.clientes"
              :options="optionsClientesGroup"
              :label="$t('label.cliente')"
              :placeholder="$t('option.select')"
              group="true"
              @change="selectClienteMulti"
            />
          </PCol>
          <PCol col="6" v-else-if="valueLocal.nivel === rolePS && valueLocal.paises[0] > 0">
            <PFormSelect
              v-model="valueLocal.clientes"
              :options="optionsClientes"
              optionValue="id"
              optionText="codDesCliente"
              :label="$t('label.cliente')"
              :placeholder="$t('option.select')"
              @change="selectCliente"
              :valueAsArray="true"
            />
          </PCol>
          <PCol
            md="12"
            v-if="valueLocal.nivel === roleDelegacion && valueLocal.clientes?.length > 0"
          >
            <PFormSelectTranslateItems
              v-model="delegacionesSeleccionadas"
              :options="optionsDelegacionesGroup"
              :group="true"
              :titleLeft="$t('label.delegacion')"
              :titleRight="$t('label.seleccionadas')"
            />
          </PCol>
          <PCol md="12" v-if="valueLocal.nivel === rolePS && valueLocal.clientes[0] > 0">
            <PFormSelectTranslateItems
              v-model="valueLocal.puntosServicio"
              :options="optionsPs"
              :group="true"
              :titleLeft="$t('label.puntoServicio')"
              :titleRight="$t('label.seleccionados')"
            />
          </PCol>
        </PRow>
        <PRow>
          <PCol col="6" v-if="valueLocal.nivel > 0 && valueLocal.nivel < 4">
            <PFormSwitch v-model="valueLocal.ntfActiva" :label="$t('label.ntfActiva')" />
          </PCol>
          <PCol col="6">
            <PFormSwitch v-model="valueLocal.active" :label="$t('label.activo')" />
          </PCol>
        </PRow>
        <PRow>
          <PCol col="6">
            <PFormSwitch
              v-model="valueLocal.ntfContactoActiva"
              :label="$t('label.notificacionContacto')"
            />
          </PCol>
          <PCol col="6" v-if="valueLocal.userType == 'CORPORATE'">
            <PFormSwitch
              v-model="valueLocal.ntfRechazos"
              :label="$t('label.notificacionRechazos')"
            />
          </PCol>
        </PRow>
      </div>
    </template>
  </PForm>
</template>
<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  ICliente,
  NIVELES_CLIENTE,
  NIVELES_DELEGACION,
  NIVELES_PAIS,
  INivel,
  IPais,
  IUsuario,
  IClientexdel,
} from "@/entities";
import { iniUsuarioParams, IUsuarioParams } from "@/services";
import { Getter } from "vuex-class";
import { SelectGroupType } from "@/components/look";
import { ROLE_CLIENTE, ROLE_DELEGACION, ROLE_PAIS, ROLE_PS } from "@/constans";
import PFormInputText from "@/components/look/PFormInputText.vue";

@Component({
  components: { PFormInputText },
})
export class UsuarioForm extends Vue {
  @Prop({ required: true }) value!: IUsuarioParams;
  @Watch("value", { immediate: true, deep: true })
  onChangeValue(): void {
    this.valueLocal = structuredClone(this.value);
    this.asignarValorOriginal();
  }
  @Prop({ required: false }) actionName!: string;
  @Getter("getPaises") getPaises!: IPais[];
  @Getter("getLoggedUser") getLoggerUser!: IUsuario;
  valueLocal: IUsuarioParams = iniUsuarioParams;
  optionsPaises: IPais[] = [];
  usuarioLogado: Partial<IUsuario> = {};
  optionsClientesGroup: SelectGroupType[] = [];
  optionsClientes: ICliente[] = [];
  optionsDelegacionesGroup: SelectGroupType[] = [];
  validado = false;
  optionsPs: SelectGroupType[] = [];
  clienteOriginal = 0;
  paisOriginal = 0;

  delegaciones: {
    id: number;
    idClientexdel: number;
    desDelegacion: string;
  }[] = [];

  mounted(): void {
    this.optionsPaises = this.getPaises;
    this.usuarioLogado = this.getLoggerUser;
    if (
      this.valueLocal.nivel === this.roleCliente ||
      this.valueLocal.nivel === this.roleDelegacion
    ) {
      this.selectPaisMulti();

      if (this.valueLocal.nivel === this.roleDelegacion) {
        this.selectClienteMulti();
      }
    }
  }

  get rolePais(): number {
    return ROLE_PAIS;
  }
  get roleCliente(): number {
    return ROLE_CLIENTE;
  }
  get roleDelegacion(): number {
    return ROLE_DELEGACION;
  }
  get rolePS(): number {
    return ROLE_PS;
  }

  get optionsNivel(): INivel[] {
    if (this.usuarioLogado.nivel === ROLE_PAIS) {
      return NIVELES_PAIS.map((nivel) => {
        nivel.descNivel = this.$t(`label.${nivel.codNivel}`);
        return nivel;
      });
    } else if (this.usuarioLogado.nivel === ROLE_CLIENTE) {
      return NIVELES_CLIENTE.map((nivel) => {
        nivel.descNivel = this.$t(`label.${nivel.codNivel}`);
        return nivel;
      });
    } else if (this.usuarioLogado.nivel === ROLE_DELEGACION) {
      return NIVELES_DELEGACION.map((nivel) => {
        nivel.descNivel = this.$t(`label.${nivel.codNivel}`);
        return nivel;
      });
    }
    return [];
  }

  get dameRoles(): string[] {
    const roles: string[] = [];
    this.valueLocal.roles?.forEach((rol) => roles.push(this.$t(`label.${rol.codRol}`)));
    return roles;
  }

  asignarValorOriginal(): void {
    if (this.valueLocal.nivel) {
      this.paisOriginal = this.valueLocal.paises?.length ? this.valueLocal.paises[0] : 0;
      this.clienteOriginal = this.valueLocal.clientes?.length ? this.valueLocal.clientes[0] : 0;
    }
  }

  selectNivel(): void {
    this.valueLocal.paises = [];
    this.valueLocal.clientes = [];
    this.valueLocal.clientesxdel = [];
    this.valueLocal.puntosServicio = [];
  }

  selectPaisMulti(): void {
    if (this.valueLocal.paises?.length) {
      // Elimina los grupos de países que ya no están seleccionados
      this.optionsClientesGroup = this.optionsClientesGroup.filter((group) =>
        this.valueLocal.paises?.includes(
          this.optionsPaises.find((p) => p.descripcion === group.name)?.id ?? -1
        )
      );

      // Añade los nuevos países seleccionados
      for (const pais of this.valueLocal.paises) {
        const descripcionPais = this.optionsPaises.find((p) => p.id === pais)?.descripcion || "";
        if (!this.optionsClientesGroup.some((pg) => pg.name === descripcionPais)) {
          this.$services.clientes.fetchClientesByPais(pais).then((response) => {
            if (response) {
              const clientesPais: SelectGroupType = {
                name: descripcionPais,
                items: [],
              };
              response.forEach((cliente) => {
                clientesPais.items.push({
                  value: cliente.id,
                  text: cliente.codCliente + " - " + cliente.desCliente,
                });
              });
              this.optionsClientesGroup.push(clientesPais);
            }
          });
        }
      }
    } else {
      this.optionsClientesGroup = [];
    }
  }

  selectPais(): void {
    if (this.valueLocal.paises && this.valueLocal.paises.length) {
      this.$services.clientes.fetchClientesByPais(this.valueLocal.paises[0]).then((response) => {
        if (response) {
          this.optionsClientes = response;
          this.optionsClientes.forEach((cliente) => {
            cliente.codDesCliente = cliente.codCliente + " - " + cliente.desCliente;
          });
          if (this.valueLocal.paises![0] != this.paisOriginal) {
            this.valueLocal.clientes = [];
            this.valueLocal.clientesxdel = [];
            this.valueLocal.puntosServicio = [];
            this.asignarValorOriginal();
          }
          this.selectCliente();
        }
      });
    }
  }

  get nivelUsuario(): string {
    const nivelLocal = this.optionsNivel;
    if (nivelLocal.length > 0) {
      return nivelLocal.find((value) => value.id === this.valueLocal.nivel)!.descNivel!;
    } else {
      return "";
    }
  }

  async selectCliente(): Promise<void> {
    if (this.valueLocal.clientes && this.valueLocal.clientes.length) {
      if (this.valueLocal.clientes[0] != this.clienteOriginal) {
        this.valueLocal.clientesxdel = [];
        this.valueLocal.puntosServicio = [];
        this.asignarValorOriginal();
      }
      const cliente = this.optionsClientes.find((c) => c.id === this.valueLocal.clientes![0]);
      if (
        cliente &&
        (this.valueLocal.nivel === ROLE_DELEGACION || this.valueLocal.nivel === ROLE_PS)
      ) {
        const clienteDetail = await this.$services.clientes._fetchCliente(cliente.id!);

        if (this.valueLocal.nivel === ROLE_DELEGACION) {
          const clientexdel = clienteDetail?.clientexdels || [];
          this.delegaciones = clientexdel.map((value) => {
            return {
              id: value.delegacion.id,
              idClientexdel: value.id,
              desDelegacion: value.delegacion.desDelegacion,
            };
          });
        } else if (this.valueLocal.nivel === ROLE_PS) {
          this.optionsPs = [];
          clienteDetail?.clientexdels.forEach((clientexdel) => {
            const delegacion: SelectGroupType = {
              name: clientexdel.delegacion.desDelegacion,
              items: [],
            };
            clientexdel.puntosservicio.forEach((puntoservicio) => {
              delegacion.items.push({
                value: puntoservicio.id,
                text: puntoservicio.desPuntoservicio,
              });
            });
            this.optionsPs.push(delegacion);
          });
        }
      }
    }
  }

  async selectClienteMulti(): Promise<void> {
    if (!this.valueLocal.clientes?.length) {
      this.optionsDelegacionesGroup = [];
      this.valueLocal.clientesxdel = [];
      return;
    }

    const clientes = await this.obtenerClientes(this.valueLocal.clientes);

    this.optionsDelegacionesGroup = this.optionsDelegacionesGroup.filter((group) =>
      clientes.some((c) => c.pais.descripcion === group.name)
    );

    const delegacionesPorPais = this.agruparDelegacionesPorPais(clientes);

    this.actualizarGruposDelegaciones(delegacionesPorPais);
    this.actualizaDelegacionesSeleccionadas();
  }

  actualizaDelegacionesSeleccionadas(): void {
    const delegacionesSeleccionadas = this.delegacionesSeleccionadas;
    const nuevosClientexdelIds: number[] = [];
    for (const group of this.optionsDelegacionesGroup) {
      for (const item of group.items) {
        if (delegacionesSeleccionadas.includes(item.value)) {
          nuevosClientexdelIds.push(...(item.clientexdelIds || []));
        }
      }
    }
    this.valueLocal.clientesxdel = nuevosClientexdelIds;
  }

  async obtenerClientes(ids: number[]): Promise<ICliente[]> {
    const clientes: ICliente[] = [];
    for (const id of ids) {
      const res = await this.$services.clientes._fetchCliente(id);
      if (res) clientes.push(res);
    }
    return clientes;
  }

  agruparDelegacionesPorPais(
    clientes: ICliente[]
  ): Map<string, { value: number; text: string; clientexdelIds: number[] }[]> {
    const delegacionesPorPais = new Map<
      string,
      { value: number; text: string; clientexdelIds: number[] }[]
    >();
    for (const cliente of clientes) {
      const paisDesc = cliente.pais.descripcion;
      if (!delegacionesPorPais.has(paisDesc)) {
        delegacionesPorPais.set(paisDesc, []);
      }
      const arr = delegacionesPorPais.get(paisDesc)!;
      cliente.clientexdels?.forEach((clientexdel: IClientexdel) => {
        const delegacionId = clientexdel.delegacion.id;
        let delegacion = arr.find((d) => d.value === delegacionId);
        if (!delegacion) {
          arr.push({
            value: delegacionId,
            text: clientexdel.delegacion.desDelegacion,
            clientexdelIds: [clientexdel.id],
          });
        } else if (!delegacion.clientexdelIds.includes(clientexdel.id)) {
          delegacion.clientexdelIds.push(clientexdel.id);
        }
      });
    }
    return delegacionesPorPais;
  }

  actualizarGruposDelegaciones(
    delegacionesPorPais: Map<string, { value: number; text: string; clientexdelIds: number[] }[]>
  ) {
    for (const [pais, delegaciones] of delegacionesPorPais.entries()) {
      const group = this.optionsDelegacionesGroup.find((o) => o.name === pais);
      if (group) {
        group.items = delegaciones;
      } else {
        this.optionsDelegacionesGroup.push({
          name: pais,
          items: delegaciones,
        });
      }
    }
  }

  private _lastDelegacionesSeleccionadas: number[] = [];

  get delegacionesSeleccionadas(): number[] {
    const delegacionIds: Set<number> = new Set();
    for (const group of this.optionsDelegacionesGroup) {
      for (const item of group.items) {
        if (item.clientexdelIds?.some((id: number) => this.valueLocal.clientesxdel?.includes(id))) {
          delegacionIds.add(item.value);
        }
      }
    }
    const result = Array.from(delegacionIds);
    // Solo retorna un nuevo array si cambia el contenido
    if (JSON.stringify(result) !== JSON.stringify(this._lastDelegacionesSeleccionadas)) {
      this._lastDelegacionesSeleccionadas = result;
    }
    return this._lastDelegacionesSeleccionadas;
  }
  set delegacionesSeleccionadas(newDelegaciones: number[]) {
    // Actualiza valueLocal.clientesxdel según las delegaciones seleccionadas
    const clientexdelIds: number[] = [];
    for (const group of this.optionsDelegacionesGroup) {
      for (const item of group.items) {
        if (newDelegaciones.includes(item.value)) {
          clientexdelIds.push(...(item.clientexdelIds || []));
        }
      }
    }
    this.valueLocal.clientesxdel = clientexdelIds;
  }

  cancel(): void {
    this.$emit("cancel");
  }
  action(action: string): void {
    this.$emit("action", { data: this.valueLocal, action: action });
  }
}
export default UsuarioForm;
</script>
